module.exports = __webpack_public_path__ + "assets/73416fcfc26ffab33bf00c8620af6703.mp3";